import React from 'react';
import { Form } from 'react-final-form';
import { Grid } from '../../../design-system';
import FieldColumn from '../../../components/FieldColumn';
import { prettyPhone, required } from '../../../helpers/utils';
import {
  COUNTRY_OPTIONS,
  STATE_OPTIONS,
  US_STATES,
} from '../../../globalConstants';

const handleOnSubmit = () => {
  // TODO: allow for agency info updates
};

interface AgencyFormProps {
  agency: any;
}

const AgencyForm = ({ agency }: AgencyFormProps) => {
  return (
    <Form
      initialValues={{
        country: 'United States',
        ...agency,
        state:
          US_STATES.find(({ abbreviation }) => abbreviation === agency.state)
            ?.name || agency.state,
        phone: agency.phone && prettyPhone(agency.phone),
      }}
      onSubmit={handleOnSubmit}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <Grid.Row auto>
            <Grid.Column size={{ _: 12, md: 6, lg: 4 }}>
              <FieldColumn
                label="Full Name"
                name="name"
                validate={required}
                disabled
              />
            </Grid.Column>
            <Grid.Column size={{ _: 12, md: 6, lg: 4 }}>
              <FieldColumn
                label="Address"
                name="address"
                validate={required}
                disabled
              />
            </Grid.Column>
            <Grid.Column size={{ _: 12, md: 6, lg: 4 }}>
              <FieldColumn
                label="City"
                name="city"
                validate={required}
                disabled
              />
            </Grid.Column>
            <Grid.Column size={{ _: 12, md: 6, lg: 4 }}>
              <FieldColumn
                name="state"
                label="State"
                component="select"
                options={values.country ? STATE_OPTIONS(values.country) : []}
                validate={required}
                disabled
              />
            </Grid.Column>
            <Grid.Column size={{ _: 12, md: 6, lg: 4 }}>
              <FieldColumn
                name="country"
                label="Country"
                component="select"
                options={COUNTRY_OPTIONS}
                validate={required}
                disabled
              />
            </Grid.Column>
            <Grid.Column size={{ _: 12, md: 6, lg: 4 }}>
              <FieldColumn
                name="zip"
                label="Zip"
                validate={required}
                disabled
              />
            </Grid.Column>
            <Grid.Column size={{ _: 12, md: 6, lg: 4 }}>
              <FieldColumn
                name="phone"
                label="Phone"
                transformOnBlur={prettyPhone}
                disabled
              />
            </Grid.Column>
          </Grid.Row>
        </form>
      )}
    />
  );
};

export default AgencyForm;
